import React, { ElementType } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useAuthProvider } from '@/store';
import { SignInRoute } from '@/models';

const BASE_URL = window.location.origin;

interface AccessDeniedProps {
  button: ElementType;
  modal: ElementType;
}

export const AccessDeniedModal = ({ button: Button, modal: Modal }: AccessDeniedProps) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const authProvider = useAuthProvider();

  const isModalOpened = (state as { isModalOpened: boolean })?.isModalOpened || false;

  const onClose = () => {
    if (authProvider) {
      const { hasLoginPage, logoutRedirectUri, fullOktaAuthUrl } = authProvider;

      if (hasLoginPage) {
        navigate(logoutRedirectUri, { state: { isModalOpened: false } });
      } else {
        history.pushState(null, '', `${BASE_URL}/${SignInRoute.AccessDenied}`);
        window.location.assign(fullOktaAuthUrl);
      }
    }
  };

  return (
    <Modal isOpen={isModalOpened} onClose={onClose}>
      <p>Access denied. Please, login</p>
      <Button onClick={onClose}>Close</Button>
    </Modal>
  );
};
